import { render, staticRenderFns } from "./ProjectExpand.vue?vue&type=template&id=786e3ba8"
import script from "./ProjectExpand.vue?vue&type=script&lang=js"
export * from "./ProjectExpand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports